// Diverging palette anchored pink (low) → grey (neutral) → blue (high). Each
// scale size gets its own ordered set so every bin renders a distinct color
// (sampling a 5-stop palette with round() collapsed neighbors on 6/7-bin scales).
const PALETTES: Record<number, string[]> = {
    1: ["bg-assessment-scale-neutral"],
    2: ["bg-assessment-scale-low", "bg-assessment-scale-high"],
    3: ["bg-assessment-scale-low", "bg-assessment-scale-neutral", "bg-assessment-scale-high"],
    4: ["bg-assessment-scale-low", "bg-assessment-scale-low-soft", "bg-assessment-scale-high-soft", "bg-assessment-scale-high"],
    5: ["bg-assessment-scale-low", "bg-assessment-scale-low-soft", "bg-assessment-scale-neutral", "bg-assessment-scale-high-soft", "bg-assessment-scale-high"],
    6: [
        "bg-assessment-scale-low-strong",
        "bg-assessment-scale-low",
        "bg-assessment-scale-low-soft",
        "bg-assessment-scale-high-soft",
        "bg-assessment-scale-high",
        "bg-assessment-scale-high-strong",
    ],
    7: [
        "bg-assessment-scale-low-strong",
        "bg-assessment-scale-low",
        "bg-assessment-scale-low-soft",
        "bg-assessment-scale-neutral",
        "bg-assessment-scale-high-soft",
        "bg-assessment-scale-high",
        "bg-assessment-scale-high-strong",
    ],
};

const FALLBACK = PALETTES[5];

// Swatches light enough to need dark labels; scale-low needs black in both themes.
const DARK_LABEL_SWATCHES = new Set(["bg-assessment-scale-low", "bg-assessment-scale-low-soft", "bg-assessment-scale-neutral", "bg-assessment-scale-high-soft"]);

export function paletteTextColor(index: number, total: number): string {
    return DARK_LABEL_SWATCHES.has(paletteColor(index, total)) ? "text-black" : "text-white";
}

export function paletteColor(index: number, total: number): string {
    const palette = PALETTES[total];
    if (palette) {
        return palette[index] ?? palette[palette.length - 1];
    }
    if (total <= 1) {
        return FALLBACK[2];
    }
    const t = index / (total - 1);
    const idx = Math.round(t * (FALLBACK.length - 1));
    return FALLBACK[idx];
}
